import React, { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useGlobalData } from '../../contextProvider/GlobalDataContext';
import { redirectInternalOrExternal } from '../../helpers/Redirect';
import PageContext from '../../contextProvider/PageContext';
import AppContext from '../App/AppContext';

import {
  NavbarContainerStyled as NavbarContainer,
  NavbarItem,
} from './styles/NavbarStyled';
import { GoogleTagManager } from '../../helpers';

const Navbar = () => {
  const { showMenuMobile, setShowMenuMobile } = useContext(AppContext);

  const handleClick = (url, buttonName) => {
    GoogleTagManager.tagInteractiveEvent({
      eventCategory: 'Navbar',
      eventAction: 'Presionar Botón',
      eventTag: `Botón Navbar ${buttonName}`,
    });

    if (url) {
      redirectInternalOrExternal(url);
      if (showMenuMobile) setShowMenuMobile(!showMenuMobile);
    } else {
      setShowMenuMobile(!showMenuMobile);
    }
  };

  const {
    location: { pathname: actualPathname },
  } = useContext(PageContext);
  const { showNavbar } = useContext(AppContext);
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)',
  });

  const { navbarData: navbarItems } = useGlobalData();
  const hasItems = navbarItems && Object.keys(navbarItems).length > 0;

  if (!isMobileDevice || !showNavbar || !hasItems) return null;
  return (
    <NavbarContainer>
      {navbarItems.map(({ icon, title, url }) => {
        const urlMatch = url.match(/\/([^/]+)\/?$/);
        const pathname = urlMatch ? urlMatch[0] : '';
        const current =
          pathname === actualPathname ||
          actualPathname.startsWith(`${pathname}/`);
        return (
          <NavbarItem
            current={
              (current && url && !showMenuMobile) || (showMenuMobile && !url)
            }
            key={title}
            onClick={() => handleClick(url, title)}
            isOne={navbarItems.length === 1}
          >
            <img src={icon.url} alt={title} />
            <p>{title}</p>
          </NavbarItem>
        );
      })}
    </NavbarContainer>
  );
};

export default Navbar;
